/*========================================
# 商品ページ 名入れ
========================================*/
var radio_val;
$('input[type="radio"]').on('click',function(){
	if($(this).val() == radio_val) {
		$(this).prop('checked', false);
		radio_val = null;
	} else {
		radio_val = $(this).val();
	}
});

$(document).ready(function() {
    toggleRequired();

    $('.name-service-checkbox').change(function() {
        toggleRequired();
    });

    function toggleRequired() {
        if ($('.name-service-checkbox').is(':checked')) {
            $('.required').attr('required', true);
        } else {
            $('.required').removeAttr('required');
        }
    }
});